import PropTypes from 'prop-types';

import {convertToInt} from '../../../../utils/helpers';
import {PROPERTY_LICENCE_TYPE_SPORTRADAR, PROPERTY_LICENCE_TYPE_STAGE_SPORT} from '../../../app/constants/variables';

export const exportExcel = (dataExport, propertyLicenceId, propertyLicenceTypeId) => {
    const typeId = convertToInt(propertyLicenceTypeId);

    let firstTitle;
    let secondTitle;

    if (typeId === PROPERTY_LICENCE_TYPE_SPORTRADAR) {
        firstTitle = 'Category';
        secondTitle = 'Tournament';
    } else if (typeId === PROPERTY_LICENCE_TYPE_STAGE_SPORT) {
        firstTitle = '1st stage category';
        secondTitle = '2nd stage category';
    } else {
        firstTitle = '2nd level category';
        secondTitle = '3rd level category';
    }

    const parseData = (content) => {
        const categoryName =
            content.tournament?.tournament_category?.name ||
            content.content_category?.parent?.name ||
            content.stage_category?.name;

        const subCategoryName =
            content.tournament?.name ||
            content.content_category?.name ||
            content.stage_category?.parent?.name;

        const tierName = content.content_tier?.name;

        return [
            categoryName,
            subCategoryName,
            tierName,
        ];
    };

    return {
        dataExport,
        filename: `property_licence_${propertyLicenceId}_content`,
        parseData,
        path: 'propertyLicences.content.index.path',
        titles: [
            firstTitle,
            secondTitle,
            'Tier',
        ],
    };
};

exportExcel.propTypes = {
    dataExport: PropTypes.array.isRequired,
};
